
import PracticQuestionSubjects from '../subjects/PracticQuestionSubjects';

function ChapterWisePYQ() {



  return (

    <>
      
      <PracticQuestionSubjects 
        name="Chapter Wise PYQ 2015 to 2026" 
        link="chapter-wise-pyq" 
        type="chapterwisepyq" 
      />

  
    </>
  );
}

export default ChapterWisePYQ;